import { useEffect, useState } from 'react';

/**
 * Reads `data-theme` off `<html>` and re-reads on change (MutationObserver). No live in-app
 * theme toggle exists yet (`data-theme="light"` is hardcoded in index.html) — this hook keeps
 * theme-dependent renders correct whenever one ships, mirroring the read+MutationObserver
 * pattern in `src/components/ui/foundations/_use-token-value.ts`.
 */
export function useDataTheme(): 'light' | 'dark' {
  const [theme, setTheme] = useState<'light' | 'dark'>(
    () => (document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light'),
  );
  useEffect(() => {
    const read = () =>
      setTheme(document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light');
    const mo = new MutationObserver(read);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => mo.disconnect();
  }, []);
  return theme;
}
